export function generateCheckoutItemViewOfferCreditKey(
  itemView:
    App.Checkout.LEAccommodationItemView |
    App.Checkout.CruiseAccommodationItemView |
    App.Checkout.BedbankAccommodationItemView |
    App.Checkout.TourV2AccommodationItemView |
    App.Checkout.FlightItemView,
) {
  // There is no consistency between the or identifying properties between views types for accommodation and flights.
  // Need to check if properties to determine if flights or accommodation.
  let itemViewUniqueKey: string = ''
  if ('uniqueKey' in itemView) {
    itemViewUniqueKey = itemView.uniqueKey
  }

  if ('journeyId' in itemView) {
    itemViewUniqueKey = itemView.journeyId ?? ''
  }

  const params = new URLSearchParams({
    itemViewUniqueKey,
    itemViewItemId: itemView.item.itemId,
  })

  return params.toString()
}
